import { FixedBoxTitle } from "pro-features/components/BoxTitle/src/FixedBoxTitle";
import type { FC } from "react";
import styled from "styled-components";
import { i18nFilter } from "app/filters/i18nFilter";
import { DownloadButtonMenu } from "app/components/React/DownloadButtonMenu/DownloadButtonMenu";
import { swSettings } from "app/common/services/swSettings";
import { allTrackers } from "app/services/track/track";
import { DefaultFetchService } from "app/services/fetchService";
import { getQueryParams } from "app/pages/website-analysis/demographicsUserBased/trafficAndEngagmentTable/utils";
import type { IFilters } from "app/pages/website-analysis/demographicsUserBased/trafficAndEngagmentTable/types";
import { colorsPalettes } from "@similarweb/styles";
import { isPaidExcelAllowed } from "app/services/PaidExcelService/isPaidExcelAllowed";

const { carbon } = colorsPalettes;

const EXCEL_ENDPOINT = "widgetApi/DemographicSegments/Buckets/Excel";

const Container = styled.div`
    padding: 20px 24px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid ${carbon[100]};
`;

interface IHeader {
    filters: IFilters;
    totalCount: number;
}

export const Header: FC<IHeader> = (props) => {
    const { filters, totalCount } = props;
    const i18n = i18nFilter();
    const downloadExcelPermitted = swSettings.current.resources.IsExcelAllowed;
    const trackingCallback = () =>
        allTrackers.trackEvent("Download", "submit-ok", "Excel/Demographics/Audience segment");
    const fetcherService = DefaultFetchService.getInstance();
    const queryParams = getQueryParams(filters);
    const excelLink = `/${EXCEL_ENDPOINT}?${fetcherService.requestParams(queryParams)}`;
    const isPaidExcelPermitted = isPaidExcelAllowed();

    return (
        <Container>
            <FixedBoxTitle
                title={i18n("demographics.user.based.compare.table.title")}
                tooltip={i18n("demographics.user.based.compare.table.title.tooltip")}
            />
            <DownloadButtonMenu
                Excel={true}
                downloadUrl={excelLink}
                excelLocked={!downloadExcelPermitted}
                trackingFunction={trackingCallback}
                PaidExcel={isPaidExcelPermitted}
                totalCount={totalCount}
            />
        </Container>
    );
};
